import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActionsService } from './actions.service';
import { GridOptions, GridReadyEvent } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss'],
})

export class ActionsComponent implements OnInit, OnDestroy {
  subscriptions: any[] = [];
  gridActions: GridOptions;
  gridData: any[] = [];
  isEdit: boolean;

  constructor(
    private actionsService: ActionsService,
    private sweetAlertHelper: SweetAlertHelper
  ) {
    this.createGrid();
  }

  ngOnInit() {
    this.getAllActions();
    this.subscribeObservables();
  }

  subscribeObservables() {
    this.subscriptions.push(
      this.actionsService.actionId$.subscribe((actionId: number) => {
        this.isEdit = actionId ? true : false;
      }),

      this.actionsService.save$.subscribe((save: boolean) => {
        this.save(save);
      })
    );
  }

  createGrid() {
    this.gridActions = <GridOptions> {
      rowSelection: 'single',
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      columnDefs: [
        {
          colId: 'actionid',
          width: 20,
          checkboxSelection: true,
        },
        {
          headerName: 'Description',
          field: 'description',
          colId: 'description',
          width: 350,
        },
      ],
      onGridReady: (params: GridReadyEvent) => {
        params.api.sizeColumnsToFit();
      },
    };
  }

  getAllActions() {
    this.subscriptions.push(
      this.actionsService.getActions().subscribe(
        (resp: any) => {
          if (resp) {
            this.gridData = resp;
          }
        },
        (error) => {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error!',
            text: error.message,
            type: 'error',
          });
        }
      )
    );
  }

  newAction() {
    this.actionsService.actionId.next(null);
    this.isEdit = true;
  }

  cellDoubleClicked(event: any) {
    if (event) {
      this.actionsService.actionId.next(event.data.actionid);
    }
  }

  editAction() {
    const action = this.getSelectedRows();
    if (action.length > 0) {
      this.actionsService.actionId.next(action[0].actionid);
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error!',
        text: 'Please select an action to edit',
        type: 'error',
      });
    }
  }

  deleteAction() {
    const action = this.getSelectedRows();
    if (action.length > 0) {
      this.sweetAlertHelper
        .createCustomAlert({
          title: 'Are you sure?',
          text: `You are about to remove the action: ${action[0].description}.`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.value) {
            this.subscriptions.push(
              this.actionsService.deleteData(action[0].actionid).subscribe(
                (resp: any) => {
                  if (resp) {
                    this.sweetAlertHelper
                      .createCustomAlert({
                        title: 'Success',
                        text: resp.message,
                        type: 'success',
                      })
                      .then(() => {
                        this.save(true);
                      });
                  }
                },
                (error) => {
                  this.sweetAlertHelper.createCustomAlert({
                    title: 'Error!',
                    text: error.message,
                    type: 'error',
                  });
                }
              )
            );
          }
        });
    } else {
      this.sweetAlertHelper
        .createCustomAlert({ text: 'Please select a row', type: 'info' })
        .then();
    }
  }

  save(save: boolean) {
    if (save) {
      this.getAllActions();
    }
    this.isEdit = null;
  }

  getSelectedRows(): any[] {
    const action = [];
    this.gridActions.api.forEachNodeAfterFilter((row) => {
      if (row.isSelected()) {
        action.push(row.data);
      }
    });
    return action;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/actions/actions.component.ts